import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import MethodChooser from "../../choosers/MethodChooser";
import ChangeByGniGroupTable from "./ChangeByGniGroupTable";

const ChangeByGniGroupTableWidget = props => {
  const [methodId, setMethodId] = useState();

  return (
    <DataViewerFrame
      reference={props.reference}
      title={props.title}
      subtitle={props.subtitle}
      filters={[
        <MethodChooser
          id={props.chooserId}
          methods={props.database.methods}
          selectedKey={methodId}
          onChange={methodId => {
            setMethodId(methodId);

            props.onChange({
              widget: `theme5.${props.id}`,
              payload: {
                methodId
              }
            });
          }}
        />
      ]}
      onDownloadCsv={() => {
        props.onDownloadCsv({
          method: methodId ? props.database.methods[methodId] : "All"
        });
      }}
    >
      <ChangeByGniGroupTable data={props.data} />
    </DataViewerFrame>
  );
};

ChangeByGniGroupTableWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  chooserId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default ChangeByGniGroupTableWidget;
